import { IconType } from "react-icons";
import {
  RiCheckboxCircleLine,
  RiMailSendLine,
  RiTimeLine
} from "react-icons/ri";

/**
 * Valores do smart enum SituacaoPendencia (backend).
 * Fluxo: AGUARDANDO_INFORMACAO -> INFORMACAO_RECEBIDA -> RESOLVIDA.
 */
export type SituacaoPendenciaValue =
  | "AGUARDANDO_INFORMACAO"
  | "INFORMACAO_RECEBIDA"
  | "RESOLVIDA";

export interface SituacaoPendenciaInfo {
  label: string;
  colorScheme: string;
  icon: IconType;
  /** Mensagem na perspectiva do cidadão. */
  descricao: string;
}

/**
 * Mapeia a situação da pendência (na visão do cidadão) para label, cor,
 * ícone e mensagem. O estado INFORMACAO_RECEBIDA é exibido como "Respondida".
 */
export function getSituacaoPendenciaInfo(
  value?: string | null
): SituacaoPendenciaInfo {
  switch (value) {
    case "AGUARDANDO_INFORMACAO":
      return {
        label: "Aguardando informação",
        colorScheme: "orange",
        icon: RiTimeLine,
        descricao: "A solicitação foi enviada e aguarda a sua resposta."
      };
    case "INFORMACAO_RECEBIDA":
      return {
        label: "Respondida",
        colorScheme: "blue",
        icon: RiMailSendLine,
        descricao:
          "A resposta foi recebida e aguarda análise da equipe solicitante."
      };
    case "RESOLVIDA":
      return {
        label: "Resolvida",
        colorScheme: "green",
        icon: RiCheckboxCircleLine,
        descricao: "A solicitação foi analisada e encerrada."
      };
    default:
      return {
        label: value ?? "-",
        colorScheme: "gray",
        icon: RiTimeLine,
        descricao: ""
      };
  }
}
